import React from 'react';

import { useNavigate } from 'react-router-dom';
import { RootState } from 'store/ducks';
import { useDispatch, useSelector } from 'react-redux';

import checklist from 'img/menu-icon-checklist.svg';
import bottles from 'img/menu-icon-bottles.svg';
import returned from 'img/menu-icon-returned.svg';
import megaphone from 'img/menu-icon-megaphone.svg';
import userIcon from 'img/menu-icon-user.svg';
import noteCorrection from 'img/icon-correction.svg';
import papper from 'img/menu-icon-papper.svg';
import documentRegulatory from 'img/icon-documents-regulatory.svg';
import { EnumCategories } from 'models/Ticket';
import iconFollowUpEntregue from 'img/icon-follow-entrega.svg';
import iconFollowUpNaoEntregue from 'img/icon-follow-nao-entregue.svg';

import FollowUpDelivered from 'components/FollowUpDeliverSlider/FollowUpDelivered';
import FollowUpNotDelivered from 'components/FollowUpDeliverSlider/FollowUpNotDelivered';
import { eventName, dashboardClienteAction } from 'components/ApplicationInsights/eventNames';
import { IMenuItem, IMenuItems } from 'components/MenuItems/interface';
import NoteCorrectionSlider from 'components/NoteCorrectionSlider';
import { useCustomEvent } from 'components/ApplicationInsights';
import ReportsSlider from 'components/ReportsSlider';
import Text from 'components/Text';
import Billet from 'components/MenuItems/Billet';
import TrackingOrder from 'components/MenuItems/TrackingOrder';
import Invoice from 'components/MenuItems/Invoice';
import XmlInvoice from 'components/MenuItems/XmlInvoice';
import Tracking from 'components/MenuItems/Tracking';

import { settings } from './interface';
import { handleDispatchOpenSlider } from 'utils/Slider';

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './styles.scss';


const MenuItem: React.FC<IMenuItem> = (props) => {
  const componentName = `Menu Cockpit Cliente`;
  const trackMenuClick = useCustomEvent(componentName, eventName.COCKPIT_CLIENTE);
  const { icon, title, subtitle, onClick, trackName } = props;

  async function clickMenu() {
    if (trackName) {
      trackMenuClick({ item: trackName });
    }

    if (onClick) {
      onClick();
    }
  }

  return (
    <button
      className="menu-item-customer bg-white shadow-1"
      onClick={clickMenu}
    >
      {icon && <img src={icon} alt="" />}
      <div>
        <Text
          size={13}
          className="mt-2 text-center color-blue-gray text-wrap font-bold"
        >
          {title}
        </Text>
        <Text
          size={13}
          className="text-center color-blue-gray text-wrap font-bold"
        >
          {subtitle}
        </Text>
      </div>
    </button>
  );
};

const MenuItemsCustomer: React.FC<IMenuItems> = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = useSelector((state: RootState) => state.user);

  const btnUsers = () => {
    if ((user?.userType === 'customer' &&
      user.roles?.includes('administrator')) ||
      (user?.userType === 'employee')) {
      return (
        <MenuItem
          title="GERENCIAR"
          subtitle="USUÁRIOS"
          icon={userIcon}
          trackName={dashboardClienteAction.DASHCLIENTE_GERENCIARUSUARIOS}
          onClick={() => {
            navigate('/gerenciar-usuarios');
          }}
        />
      );
    }
  };


  return (
    <>
      <Slider className="slider-buttons" {...settings}>
        <Billet itemComponent={MenuItem} />
        <TrackingOrder itemComponent={MenuItem} />
        <Invoice itemComponent={MenuItem} />
        <XmlInvoice itemComponent={MenuItem} />
        <MenuItem
          title="FICHAS &"
          subtitle="LAUDOS"
          icon={checklist}
          trackName={dashboardClienteAction.DASHCLIENTE_LAUDOSFICHAS}
          onClick={() =>
            dispatch({
              type: 'OPEN_SLIDER',
              data: {
                title: 'Fichas & Laudos',
                subtitle:
                  'Utilize os campos abaixo para localizar o seu pedido.',
                show: true,
                content: ReportsSlider,
              },
            })
          }
        />
        <Tracking itemComponent={MenuItem} />
        <MenuItem
          title="CORREÇÃO DA"
          subtitle="NOTA FISCAL"
          icon={noteCorrection}
          trackName={dashboardClienteAction.DASHCLIENTE_NOTACORRECAO}
          onClick={() =>
            dispatch({
              type: 'OPEN_SLIDER',
              data: {
                title: 'Correção da nota fiscal',
                subtitle:
                  'Utilize os campos abaixo para localizar o seu pedido.',
                show: true,
                content: NoteCorrectionSlider,
              },
            })
          }
        />
        {btnUsers()}
        <MenuItem
          title="SOLICITAR"
          subtitle="DEVOLUÇÃO"
          icon={returned}
          trackName={dashboardClienteAction.DASHCLIENTE_SOLICITARDEVOLUCAO}
          onClick={() => {
            navigate('/abrir-protocolo', {
              state: {
                protocolCategory: '1',
              },
            });
          }}
        />
        <MenuItem
          title="RECLAMAÇÃO"
          subtitle="TÉCNICA"
          icon={megaphone}
          trackName={dashboardClienteAction.DASHCLIENTE_RECLAMACAOTECNICA}
          onClick={() => {
            navigate('/abrir-protocolo', {
              state: {
                protocolCategory: EnumCategories.RECLAMACAO_TECNICA,
              }
            });
          }}
        />
        <MenuItem
          title="CONSULTA"
          subtitle="DE PRODUTOS"
          icon={bottles}
          trackName={dashboardClienteAction.DASHCLIENTE_CONSULTAPRODUTOS}
          onClick={() => {
            navigate('/produtos');
          }}
        />
        <MenuItem
          title="POLÍTICAS"
          subtitle="DE NEGÓCIO"
          icon={papper}
          trackName={dashboardClienteAction.DASHCLIENTE_POLITICASNEGOCIO}
          onClick={() => {
            navigate('/politicas', { state: { politicBusiness: true } });
          }}
        />
        <MenuItem
          title="DOCUMENTOS"
          subtitle="LEGAIS VIVEO"
          icon={documentRegulatory}
          trackName={dashboardClienteAction.DASHCLIENTE_DOCUMENTOSREGULATORIOS}
          onClick={() => {
            navigate('/politicas', { state: { regulatoryDocument: true } });
          }}
        />
        <MenuItem
          title="FOLLOW-UP"
          subtitle="DE ENTREGAS"
          icon={iconFollowUpEntregue}
          trackName={dashboardClienteAction.DASHCLIENTE_FOLLOWUPENTREGAS}
          onClick={() => {
            handleDispatchOpenSlider({
              title: "Follow-up de Entregas",
              subtitle: "Utilize os campos abaixo para gerar o relatório.",
              show: true,
              content: FollowUpDelivered,
              dispatch
            });
          }}
        />

        <MenuItem
          title="FOLLOW-UP"
          subtitle="NÃO ENTREGUES"
          icon={iconFollowUpNaoEntregue}
          trackName={dashboardClienteAction.DASHCLIENTE_FOLLOWUPNAOENTREGUE}
          onClick={() => {
            handleDispatchOpenSlider({
              title: "Follow-up Não Entregues",
              subtitle: "Utilize os campos abaixo para gerar o relatório.",
              show: true,
              content: FollowUpNotDelivered,
              dispatch
            });
          }}
        />
      </Slider>
    </>
  );
};

export default MenuItemsCustomer;
